export const REGEXP_UID = /[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}/g;
export const FIRST_TIMEOUT_TO_REQUEST = 10000;
export const TIMEOUT_TO_REQUEST_OFFLINE = 2000;
export const TIMEOUT_TO_REQUEST_ONLINE = 15000;
